import React from "react";

/** Premium loan-offer visual — abstract fintech, no cartoon characters */
const OfferHeroArt = () => (
  <div className="fw-offer-artwrap" aria-hidden="true">
    <span className="fw-offer-artwrap__glow" />

    <div className="fw-offer-viz">
      <span className="fw-offer-viz__ring fw-offer-viz__ring--outer" />
      <span className="fw-offer-viz__ring fw-offer-viz__ring--mid" />

      <div className="fw-offer-viz__core">
        <span className="fw-offer-viz__rupee">₹</span>
        <span className="fw-offer-viz__check">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path
              d="M5 13l4 4L19 7"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>

      <span className="fw-offer-viz__chip fw-offer-viz__chip--1">Instant</span>
      <span className="fw-offer-viz__chip fw-offer-viz__chip--2">Secure</span>

      <span className="fw-offer-viz__dot fw-offer-viz__dot--1" />
      <span className="fw-offer-viz__dot fw-offer-viz__dot--2" />
      <span className="fw-offer-viz__dot fw-offer-viz__dot--3" />
      <span className="fw-offer-viz__dot fw-offer-viz__dot--4" />
    </div>
  </div>
);

export default OfferHeroArt;
